// extracted by mini-css-extract-plugin
export default {"container":"main-info-item-empty_container__3dZ0Y","line1":"main-info-item-empty_line1__MozeA"};